export function escapeCsvValue(value) {
    const text = value === null || value === undefined ? '' : `${value}`;
    if (text.includes('"') || text.includes(',') || text.includes('\n')) {
        return `"${text.replace(/"/g, '""')}"`;
    }
    return text;
}

export function toIsoString(ts) {
    if (!ts) return '';
    if (typeof ts.toDate === 'function') return ts.toDate().toISOString();
    if (typeof ts.toMillis === 'function') return new Date(ts.toMillis()).toISOString();
    if (ts instanceof Date) return ts.toISOString();
    return '';
}

/** Team: auto when !claimedBy (default owner tag). Individual: auto when claimType is autoClaim/thirdPartyAutoClaim. */
export function getIsAutoClaimed(tag) {
    if (tag.teamId) return !tag.claimedBy;
    const ct = (tag.claimType || '').toLowerCase();
    return ct === 'autoclaim' || ct === 'thirdpartyautoclaim';
}
